<template>
  <div class="main">
    <back :title="headtitle"></back>
    <div style="width:100%;height:100%;padding:10px;">
      <h2 style="text-align:center;padding:10px;">{{ datas.title }}</h2>
      <van-image :src="datas.cover_url"></van-image>
      <div class="content" v-html="datas.content"></div>
    </div>
    <allMenu></allMenu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [],
      headtitle: "",
    };
  },
  components: {
    back: () => import("../../../components/head/back"),
    allMenu: () => import("@/components/menu/allMenu"),
  },
  methods: {
    getDetail(param) {
      this.$axios
        .get("http://api.cdomick.com/index.php/wap/articledetail", {
          // .get("http://localhost/index.php/wap/articledetail", {
          params: {
            id: param,
          },
        })
        .then((response) => {
          console.log(response.data.data)
          this.datas = response.data.data;
          this.headtitle = response.data.data.from_label_desc;
        });
    },
  },

  mounted() {
    console.log(this.$route.params.id);
    let id = this.$route.params.id;
    this.getDetail(id);
  },
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 50px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
